// ESTÁNDAR DE DISEÑO (sistema aprobado 2026-09-18).
//
// El encabezado es una SUPERFICIE BLANCA con borde azul tenue, igual en todos
// los módulos. El color del módulo NO pinta el fondo: aparece solo en el TAG
// que va junto al título (uno de los tres únicos sitios donde se usa, junto
// con el ítem activo del nav y el botón primario de la pantalla).
//
// Cambio respecto a la versión anterior: se retiraron los degradados de color
// a todo el ancho. El documento los prohíbe explícitamente ("nada de banners
// de color a pantalla completa por página", "nada de degradado en títulos ni
// texto"), y con nueve módulos el degradado competía con el contenido en vez
// de orientar.
//
// `tone` sigue siendo la clave del módulo, así que ninguna pantalla necesita
// cambiar su llamada. Lo que cambió es cómo se dibuja.
const TONES = {
  default: { acento: "text-neutro", fondo: "bg-neutro-bg", etiqueta: "GestionIT" },
  tareas: { acento: "text-tareas", fondo: "bg-tareas-bg", etiqueta: "Tareas" },
  proyectos: { acento: "text-proyectos", fondo: "bg-proyectos-bg", etiqueta: "Proyectos" },
  soporte: { acento: "text-soporte", fondo: "bg-soporte-bg", etiqueta: "Soporte" },
  itam: { acento: "text-activos", fondo: "bg-activos-bg", etiqueta: "Activos" },
  reportes: { acento: "text-reportes", fondo: "bg-reportes-bg", etiqueta: "Reportes" },
  herramientas: { acento: "text-herramientas", fondo: "bg-herramientas-bg", etiqueta: "Herramientas" },
  compras: { acento: "text-compras", fondo: "bg-compras-bg", etiqueta: "Compras" },
  tiendas: { acento: "text-tiendas", fondo: "bg-tiendas-bg", etiqueta: "Tiendas" },
  // Alias histórico: algunas pantallas pasan tone="cyan".
  cyan: { acento: "text-herramientas", fondo: "bg-herramientas-bg", etiqueta: "Herramientas" },
};

export default function PageHeader({ title, subtitle, children, controlsClassName = "", tone = "default" }) {
  const t = TONES[tone] || TONES.default;
  return (
    // Mismo ancho que el cuerpo de la página (96%, sin tope fijo) para que
    // header y contenido lean como un solo bloque. Sin margen abajo: pegado
    // al contenido, que es la regla de "primer cuadro sin espacio".
    <div className="sticky top-0 z-10 mx-auto w-[96%] max-w-pagina">
      <div className="flex flex-wrap items-center gap-3 rounded-xl border-[1.5px] border-linea bg-superficie/95 px-4 py-3 backdrop-blur-md sm:px-5">
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2.5">
            {/* Pedido 2026-09-19: sin tag de módulo; el color del módulo lo
                lleva directamente el TÍTULO. */}
            <h1 className={`text-[18px] font-bold ${t.acento}`}>{title}</h1>
            {subtitle && (
              <span className="chip bg-relleno text-tinta-2">{subtitle}</span>
            )}
          </div>
        </div>
        <div className={`relative top-[6px] flex flex-wrap items-center gap-2 [zoom:0.86] ${controlsClassName}`}>{children}</div>
      </div>
    </div>
  );
}
